import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const SuggestionWrapper = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border: 2px solid ${({ theme }) => theme.palette.border};
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  box-shadow: ${({ theme }) => theme.boxshadow.standard};
  z-index: 1;
  padding: ${({ theme }) => theme.spacing.standard}
    ${({ theme }) => theme.spacing.small} 0;
`;

export const SuggestionHeading = styled.p`
  font-weight: bold;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
`;

export const SuggestionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Suggestion = styled.li`
  background: ${({ theme, $highlighted }) =>
    $highlighted ? theme.palette.lightBackgroundHover : theme.palette.white};
  padding: ${({ theme }) => theme.spacing.tiny}
    ${({ theme }) => theme.spacing.small};
  margin: 0 -${({ theme }) => theme.spacing.small};
  line-height: ${({ theme }) => theme.spacing.medium};
  cursor: pointer;
`;

export const SuggestionIcon = styled(SVG)`
  color: black;
  width: ${({ theme }) => theme.spacing.standard};
  height: ${({ theme }) => theme.spacing.standard};
  margin-right: ${({ theme }) => theme.spacing.tiny};
`;
